import {Action, Catalog} from '../../../common/types/common';
import {LoanApplication, SummaryState} from '../types/reducers';

export const ON_LOAD_APPROVED_APPLICATIONS_SUMMARY_ACTION: Action = {
    name: 'ON_LOAD_APPROVED_APPLICATIONS_SUMMARY_ACTION',
    action: () => ({
        type: ON_LOAD_APPROVED_APPLICATIONS_SUMMARY_ACTION.name
    })
};

export const GOT_APPROVED_APPLICATIONS_SUMMARY_ACTION: Action = {
    name: 'GOT_APPROVED_APPLICATIONS_SUMMARY_ACTION',
    action: (summary: SummaryState) => ({
        summary,
        type: GOT_APPROVED_APPLICATIONS_SUMMARY_ACTION.name
    })
};

export const ON_LOAD_APPROVED_APPLICATIONS_LIST_ACTION: Action = {
    name: 'ON_LOAD_APPROVED_APPLICATIONS_LIST_ACTION',
    action: (lastPage: number) => ({
        lastPage,
        type: ON_LOAD_APPROVED_APPLICATIONS_LIST_ACTION.name
    })
};

export const GOT_APPROVED_APPLICATIONS_LIST_ACTION: Action = {
    name: 'GOT_APPROVED_APPLICATIONS_LIST_ACTION',
    action: (lastPage: number, loanApplications: LoanApplication[], totalElements: number) => ({
        lastPage,
        loanApplications,
        totalElements,
        type: GOT_APPROVED_APPLICATIONS_LIST_ACTION.name
    })
};

export const ON_CHANGE_APPROVED_APPLICATIONS_SEARCH_ACTION: Action = {
    name: 'ON_CHANGE_APPROVED_APPLICATIONS_SEARCH_ACTION',
    action: (ots: string) => ({
        ots,
        type: ON_CHANGE_APPROVED_APPLICATIONS_SEARCH_ACTION.name
    })
};

export const ON_CHANGE_APPROVED_APPLICATIONS_FINANCIERA_FILTER_ACTION: Action = {
    name: 'ON_CHANGE_APPROVED_APPLICATIONS_FINANCIERA_FILTER_ACTION',
    action: (financiera: Catalog) => ({
        financiera,
        type: ON_CHANGE_APPROVED_APPLICATIONS_FINANCIERA_FILTER_ACTION.name
    })
};

export const ON_CHANGE_APPROVED_APPLICATIONS_STATUS_FILTER_ACTION: Action = {
    name: 'ON_CHANGE_APPROVED_APPLICATIONS_STATUS_FILTER_ACTION',
    action: (status: Catalog) => ({
        status,
        type: ON_CHANGE_APPROVED_APPLICATIONS_STATUS_FILTER_ACTION.name
    })
};

export const ON_CONFIRM_EXPORT_APPROVED_APPLICATIONS_ACTION: Action = {
    name: 'ON_CONFIRM_EXPORT_APPROVED_APPLICATIONS_ACTION',
    action: () => ({
        type: ON_CONFIRM_EXPORT_APPROVED_APPLICATIONS_ACTION.name
    })
};

export const GOT_APPROVED_APPLICATIONS_EXPORT_ACTION: Action = {
    name: 'GOT_APPROVED_APPLICATIONS_EXPORT_ACTION',
    action: (fileName: string, url: string) => ({
        fileName,
        url,
        type: GOT_APPROVED_APPLICATIONS_EXPORT_ACTION.name
    })
};

export const FAILED_APPROVED_APPLICATIONS_EXPORT_ACTION: Action = {
    name: 'FAILED_APPROVED_APPLICATIONS_EXPORT_ACTION',
    action: () => ({
        type: FAILED_APPROVED_APPLICATIONS_EXPORT_ACTION.name
    })
};

export const ON_PRESS_EDIT_APPROVED_APPLICATION_ACTION: Action = {
    name: 'ON_PRESS_EDIT_APPROVED_APPLICATION_ACTION',
    action: (token: string, consecutivo: string) => ({
        token,
        consecutivo,
        type: ON_PRESS_EDIT_APPROVED_APPLICATION_ACTION.name
    })
};

export const ON_SCROLL_TO_LOAN_SECTION_ACTION: Action = {
    name: 'ON_SCROLL_TO_LOAN_SECTION_ACTION',
    action: (sectionId: string) => ({
        sectionId,
        type: ON_SCROLL_TO_LOAN_SECTION_ACTION.name
    })
};

export const ON_LOAD_APPROVED_APPLICATIONS_HISTORY_ACTION: Action = {
    name: 'ON_LOAD_APPROVED_APPLICATIONS_HISTORY_ACTION',
    action: (lastPage: number) => ({
        lastPage,
        type: ON_LOAD_APPROVED_APPLICATIONS_HISTORY_ACTION.name
    })
};

export const GOT_APPROVED_APPLICATIONS_HISTORY_ACTION: Action = {
    name: 'GOT_APPROVED_APPLICATIONS_HISTORY_ACTION',
    action: (lastPage: number, loanApplications: LoanApplication[], totalElements: number) => ({
        lastPage,
        loanApplications,
        totalElements,
        type: GOT_APPROVED_APPLICATIONS_HISTORY_ACTION.name
    })
};

export const ON_CHANGE_APPROVED_APPLICATIONS_HISTORY_SINCE_ACTION: Action = {
    name: 'ON_CHANGE_APPROVED_APPLICATIONS_HISTORY_SINCE_ACTION',
    action: (since: string) => ({
        since,
        type: ON_CHANGE_APPROVED_APPLICATIONS_HISTORY_SINCE_ACTION.name
    })
};

export const ON_CHANGE_APPROVED_APPLICATIONS_HISTORY_UNTIL_ACTION: Action = {
    name: 'ON_CHANGE_APPROVED_APPLICATIONS_HISTORY_UNTIL_ACTION',
    action: (until: string) => ({
        until,
        type: ON_CHANGE_APPROVED_APPLICATIONS_HISTORY_UNTIL_ACTION.name
    })
};

export const SET_APPROVED_APPLICATIONS_HISTORY_FILTER_ERROR_ACTION: Action = {
    name: 'SET_APPROVED_APPLICATIONS_HISTORY_FILTER_ERROR_ACTION',
    action: (filterError: string) => ({
        filterError,
        type: SET_APPROVED_APPLICATIONS_HISTORY_FILTER_ERROR_ACTION.name
    })
};

export const ON_CONFIRM_EXPORT_APPROVED_APPLICATIONS_HISTORY_ACTION: Action = {
    name: 'ON_CONFIRM_EXPORT_APPROVED_APPLICATIONS_HISTORY_ACTION',
    action: () => ({
        type: ON_CONFIRM_EXPORT_APPROVED_APPLICATIONS_HISTORY_ACTION.name
    })
};

export const GOT_APPROVED_APPLICATIONS_HISTORY_EXPORT_ACTION: Action = {
    name: 'GOT_APPROVED_APPLICATIONS_HISTORY_EXPORT_ACTION',
    action: (fileName: string, url: string) => ({
        fileName,
        url,
        type: GOT_APPROVED_APPLICATIONS_HISTORY_EXPORT_ACTION.name
    })
};

export const FAILED_APPROVED_APPLICATIONS_HISTORY_EXPORT_ACTION: Action = {
    name: 'FAILED_APPROVED_APPLICATIONS_HISTORY_EXPORT_ACTION',
    action: () => ({
        type: FAILED_APPROVED_APPLICATIONS_HISTORY_EXPORT_ACTION.name
    })
};
